import { combineReducers } from "redux";

import addEventReducer from "./reducers/rapidAdminReducers/calendarReducers/addEventReducer";

const reducers = combineReducers ( {
	AddCalEventState : addEventReducer ,
} );

export default reducers;